import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_calendar_upcoming_scheduled_event_lists_action,
  get_calendar_past_scheduled_event_lists_action,
} from "../../redux/_actions";

function useCalendarDashboardComponent({ props }) {
  const [calendarInterviewsLoading, setCalendarInterviewsLoading] =
    useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [calendarUpcomingInterviews, setCalendarUpcomingInterviews] = useState(
    {}
  );
  const [calendarPastInterviews, setCalendarPastInterviews] = useState({});

  const { calendarUpcomingScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_upcoming_scheduled_event_lists_data_reducer
  );

  const { calendarPastScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_past_scheduled_event_lists_data_reducer
  );

  useEffect(() => {
    callCalendarInterviewsApi();
  }, []);

  useEffect(() => {
    if (calendarUpcomingScheduledEventListsData?.data) {
      setCalendarUpcomingInterviews(
        calendarUpcomingScheduledEventListsData?.data
      );
    }
  }, [calendarUpcomingScheduledEventListsData]);
  useEffect(() => {
    if (calendarPastScheduledEventListsData?.data) {
      setCalendarPastInterviews(calendarPastScheduledEventListsData?.data);
    }
  }, [calendarPastScheduledEventListsData]);

  const callCalendarInterviewsApi = async () => {
    setCalendarInterviewsLoading(true);
    await dispatch(get_calendar_upcoming_scheduled_event_lists_action());
    await dispatch(get_calendar_past_scheduled_event_lists_action());
    setCalendarInterviewsLoading(false);
  };

  const onViewCalendarClick = () => {
    navigate("/calender-dashboard");
  };

  const onJoinHMSClick = (eventId, id) => {
    if (id !== null) {
      navigate(`/scheduled-interview/join-new-event/${eventId}/${id}`);
    }
  };

  return {
    calendarInterviewsLoading,
    calendarPastInterviews,
    calendarUpcomingInterviews,
    onViewCalendarClick,
    onJoinHMSClick,
  };
}

export default useCalendarDashboardComponent;
